import React from 'react'
import './RangeSelector.scss'

const RangeSelector = (props) => {
    const step = props.step || 1;
    const value = props.value || 0;
    const min = props.min || 0;
    const max = props.max || value;

    return (
        <div className="range-selector">
            <button 
                type="button"
                className={"range-selector-button" + (value <= min ? ' range-selector-button--disabled' : '')}
                onClick={() => props.onValueChange(Math.max(value-step, min))}                
                >
                -
            </button>
            {value}
            <button 
                type="button"
                className={"range-selector-button" + (value >= min ? ' range-selector-button--disabled' : '')}
                onClick={() => props.onValueChange(Math.min(value+step, max))}
                >
                +
            </button>
        </div>  
    )
} 

export default RangeSelector


// WEBPACK FOOTER //
// ./src/components/RangeSelector.jsx